import { ReactNode, Ref, useState } from "react";
import { CoreButton } from "@verity/components/core";
import previewPoster from "./media/verity-demo-preview.webp";
import previewVideo from "./media/verity-demo-preview.mp4";

export default function DemoPreview({
	onPreview,
	rootRef,
	children,
}: {
	onPreview: () => void;
	rootRef?: Ref<HTMLDivElement>;
	children?: ReactNode;
}) {
	const [reduceMotion] = useState(() => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches ?? false);

	return (
		<div ref={rootRef} className={`demo-preview${children ? " demo-preview-modal-open" : ""}`}>
			<video
				className="demo-preview-video"
				src={previewVideo}
				poster={previewPoster}
				aria-label="A recorded walkthrough of a proctored session."
				autoPlay={!reduceMotion}
				preload={reduceMotion ? "none" : "auto"}
				muted
				loop
				playsInline
			/>
			<div className="demo-preview-overlay">
				<CoreButton className="demo-preview-cta" variant="contained" size="large" onClick={onPreview}>
					Preview Instructor Experience
				</CoreButton>
			</div>
			{children}
		</div>
	);
}
